import { CSSProperties } from 'react';
import Close from 'assets/icons/cross.png';
import Image from 'next/image';
import ReactModal, { Props } from 'react-modal';

export interface BottomSheetProps extends Props {
  title?: string;
  summary?: JSX.Element | string;
}

function BottomSheet(props: BottomSheetProps) {
  const { title, summary, onRequestClose } = props;

  return (
    <ReactModal
      ariaHideApp={false}
      className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-rounded-xl tw-bg-white tw-shadow-lg tw-outline-none tw-duration-300 tw-ease-in"
      overlayClassName="tw-fixed tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-z-[100] tw-flex tw-items-center tw-justify-center tw-bg-modal-bg"
      shouldCloseOnOverlayClick={true}
      {...props}
    >
      <div className="bg-white w-full" style={styles.container}>
        {title && (
          <div className="text-center tw-relative tw-p-3" style={styles.title}>
            {title}
            {onRequestClose ? (
              <div style={styles.close}>
                <Image alt="close" src={Close} onClick={onRequestClose} />
              </div>
            ) : null}
          </div>
        )}
        {summary ? <div className="tw-p-3">{summary}</div> : null}
      </div>
    </ReactModal>
  );
}

const styles: { [key: string]: CSSProperties } = {
  container: {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  title: {
    borderBottom: '1px solid #ccc',
    fontSize: '20px',
  },
  close: {
    top: 0,
    bottom: 0,
    right: 20,
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 10,
  },
};

export default BottomSheet;
